import { ReactElement, useState, useEffect, useCallback } from 'react';

import { FormHandles } from '@unform/core';
import { useParams } from 'react-router-dom';

import { Input } from '~/components';
import { useLoading } from '~/hooks/loading';
import { TrainingStoreService } from '~/services';

import * as S from './styles';

interface IEditTrainingStoreFormProps {
  formName: string;
  formRef: React.RefObject<FormHandles>;
  handleSubmit: (data: ITrainingStoreData) => void;
}

export interface ITrainingStoreData {
  category: string;
  description: string;
}

interface IEditTrainingStoreFormParams {
  trainingStoreId: string;
}

function EditTrainingStoreForm({
  formName,
  formRef,
  handleSubmit,
}: IEditTrainingStoreFormProps): ReactElement {
  const { setLoading } = useLoading();
  const [trainingStore, setTrainingStore] = useState<ITrainingStoreData>();
  const [initialData, setInitialData] = useState<ITrainingStoreData>();
  const { trainingStoreId } = useParams<IEditTrainingStoreFormParams>();

  const getTrainingStoreData = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await TrainingStoreService.getTrainingStoreById(
        trainingStoreId,
      );
      setTrainingStore({
        category: data.category,
        description: data.description,
      });

      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }, [trainingStoreId]);

  useEffect(() => {
    getTrainingStoreData();
  }, [getTrainingStoreData]);

  useEffect(() => {
    setInitialData({
      category: trainingStore?.category ?? '',
      description: trainingStore?.description ?? '', // exercise quando retorna do servidor caso for editar // segmentName quando for criar
    });
    formRef.current?.setFieldValue('name', trainingStore?.category);
    formRef.current?.setFieldValue(
      'training_store_exercises',
      trainingStore?.description,
    );
  }, [formRef, trainingStore?.category, trainingStore?.description]);

  return (
    <S.FormWrapper
      id={formName}
      ref={formRef}
      onSubmit={handleSubmit}
      initialData={initialData}
      style={{ maxWidth: '320px' }}
    >
      <Input name="category" readOnly label="Categoria" />
      <Input name="description" label="Tipo" />
    </S.FormWrapper>
  );
}

export default EditTrainingStoreForm;
